'use client';

import { useEffect } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { Box, Button, Container, Flex, Heading, Text } from '@shared/ui-kit';

const PageError = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  const t = useTranslations('ErrorPage');

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <Container pt="16">
      <Flex
        direction="column"
        alignItems="center"
      >
        <Box mb="10">
          <Image
            src="/error-page.svg"
            width={350}
            height={350}
            alt="Attention sign"
            color="gray.700"
          />
        </Box>
        <Heading mb="20">{t('title')}</Heading>
        <Box maxW="1095">
          <Text
            display="inline"
            fontSize="18"
            lineHeight="7"
            color="gray.700"
          >
            {t('descriptionBeforeAction')}
            &nbsp;
            <Button
              display="inline"
              variant="ghost"
              fontSize="18"
              lineHeight="7"
              fontWeight="bold"
              onClick={() => {
                reset();
              }}
            >
              {t('reloadButton')}
            </Button>
            &nbsp;
            {t('descriptionAfterAction')}
          </Text>
        </Box>
      </Flex>
    </Container>
  );
};
export default PageError;
